import React from 'react';

export default function Component(props) {

const { question, answersList, ansNPSInput, surveyLanguageCode, surveyScreenData, SurveyAttributes, themeObj, isMobile } = props;
  let [showValue, handleValue ] = React.useState(false)
  let [showValue2, handleValue2 ] = React.useState(111)

function CustomLabels(optionID,optionName, question){
  let surveyLanguageCode = "customNPS";
  return  (surveyLanguageCode!=='')?
  (question && question.transl && 
    question.transl[surveyLanguageCode] && 
        question.transl[surveyLanguageCode][optionID])?
          question.transl[surveyLanguageCode][optionID]:optionName
  :optionName
}

  


function NPSColor(question){

  function NPSName(optionID, optionName, surveyLanguageCode, question){
    return  (surveyLanguageCode!=='')?
    (question && question.transl && 
      question.transl[surveyLanguageCode] && 
        question.transl[surveyLanguageCode].optionsList && 
          question.transl[surveyLanguageCode].optionsList[optionID])?
            question.transl[surveyLanguageCode].optionsList[optionID]:optionName
    :optionName
  }

  // CustomLabels("Ratehere", "Rate here",question);

  let Color = "#a3a3a3";
  let Name = NPSName("Ratehere", CustomLabels("Ratehere", "Rate here",question), surveyLanguageCode, question)
  let answer = parseInt(answersList[answersList.findIndex(item => item.questionId === question.id)].answer);
  if(showValue || showValue===0){
    answer = showValue;
  }

  
  if(answer === 0 || answer === 1 || answer === 2 || answer === 3 || answer === 4 || answer === 5 || answer === 6 ){
    // Color = "#ed3e34";
    if(answer === 0 || answer === 1 || answer === 2){
      Name = NPSName("Extremelydissatisfied", CustomLabels("Extremelydissatisfied", "Extremely dissatisfied",question) , surveyLanguageCode, question)
      Color = "#ed3e34";
    }
    else if(answer === 3 || answer === 4){
      Name = NPSName("Dissatisfied", CustomLabels("Dissatisfied", "Dissatisfied",question) , surveyLanguageCode, question)
      console.log('Dissatisfied Name: ',Name)
      Color = "#ed3e34";
    }
    else if(answer === 5 || answer === 6){
      Name = NPSName("Neither",CustomLabels("Neither", "Neither",question), surveyLanguageCode, question)
      Color = "#fcb817";

    }
  }
  else if(answer === 7 || answer === 8){
    Color = "#0acc4b";
    Name = NPSName("Satisfied", CustomLabels("Satisfied", "Satisfied",question), surveyLanguageCode, question)
  }
  else if(answer === 9 || answer === 10){
    Color = "#0acc4b";
    Name = NPSName("Extremelysatisfied",  CustomLabels("Extremelysatisfied", "Extremely satisfied",question) , surveyLanguageCode, question)
  }

  return {
    color:Color,
    name:Name
  }
}


//console.log("question=========>",question)

function matchAnswer(answersList1,question1){
  let value = "";
  if(answersList1 && answersList1.length>0){
    let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
    if(getIndex1!==-1){
      value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].answer?answersList1[getIndex1].answer:"";
    }
  }
  return value
}

console.log("matchAnswer(answersList,question)--->",matchAnswer(answersList,question))



return(
  <>
  {/* <span className="italic text-gray-500 text-sm px-4">10 = great place to work, 1 = not so great place to work *</span> */}
  <span className={(isMobile?"text-sm ":"text-base ")+ " text-white pt-4 px-4 md:hidden block italic font-medium"} 
  style={{color:themeObj["textColor"]}} >
    {SurveyAttributes("I am not like this")?SurveyAttributes("I am not like this"):"I am not like this"}
    </span>

    <div className="grid md:grid-cols-11 grid-cols-6 gap-4 md:py-6 py-2  lg:text-lg text-sm mx-4">
      {/* 1 */}
      {[...Array(11).keys()].map((value,index)=>
      <>
      {((value).toString()===matchAnswer(answersList,question))?
        <>
        <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
        style={{background:themeObj["optionBgActiveColor"], color:themeObj["optionTextActiveColor"], borderColor:themeObj["optionBorderActiveColor"]}}
        className="my-2 bg-red-500 rounded-md md:p-4 md:py-4 p-4 py-2 text-white border border-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer px-3">
        {value}
        </span>
        </>
        :
      <>
      {(value) <= (showValue || parseInt(matchAnswer(answersList,question)))?
      <>
        <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
        style={{background:themeObj["optionBgActiveColor"], color:themeObj["optionTextActiveColor"], borderColor:themeObj["optionBorderActiveColor"]}}
        className="my-2 bg-red-500  rounded-md md:p-4 md:py-4 p-4  text-white border border-white  flex items-center justify-center  hover:bg-red-400  font-medium  cursor-pointer   px-3">
          {value}
        </span>
        </>
      :
      <>
      <span onMouseEnter={()=>handleValue2((value))}  onClick={()=>ansNPSInput((value).toString(),question)} key={index}
          style={{background:themeObj["optionBgColor"], color:themeObj["optionTextColor"], borderColor:themeObj["optionBorderColor"]}}
          className={"hover:bg-white/40 hover:text-white border-white bg-white/10 border my-2  rounded-md md:p-4 md:py-4 p-4  flex items-center  justify-center text-[#3D405B]   font-medium  cursor-pointer  px-3 transition-all duration-200"}>
        {value}
        </span>
      </>
      }
      </>
      }
      </>
      )}

    </div>

    <div className="flex md:justify-between justify-end text-white italic" style={{color:themeObj["textColor"]}}>
      <span className={(isMobile?"text-sm ":"text-base ")+" px-4 font-medium md:block hidden"}>{SurveyAttributes("I am not like this")?SurveyAttributes("I am not like this"):"I am not like this"}</span>
      <span className={(isMobile?"text-sm ":"text-base ")+" px-4 font-medium"}>{SurveyAttributes("I am like this")?SurveyAttributes("I am like this"):"I am like this"}</span>
    </div>
   


</>
  );}